// extracted by mini-css-extract-plugin
export default {"privacyNotice":"styles_privacyNotice__uji6I","content":"styles_content__97-Sh","icon":"styles_icon__kvXPa","text":"styles_text__ekHwx"};